export class DashboardGridInputs {
	Identifier: string;
	dashbaordId: string;
	values: string;
	unmfyvalues: string;
}